import type { OrderConfig } from '../../default/order/order.types';
import type { DeepPartial } from '../../default/types';
import defaultConfig from '../../default';

export const orderConfig: DeepPartial<OrderConfig> = {
  paths: {
    ...defaultConfig.order.paths,
    payment: defaultConfig.order.paths.delivery,
    checkandorder: defaultConfig.order.paths.delivery,
  },
  premium: { enabled: false },
  accountInformation: {
    bankTransferEnabled: false,
    bicAvailable: false,
  },
  hasCo2Compensation: false,
  recommendations: {
    wishlist: {
      similarProducts: {
        isEnabled: false,
        type: 'searchReplace',
      },
    },
  },
  aplusIdentifier: 'itemOptionCommKey',
};
